import { z } from "zod/v4";

// Unless jitless, zod probes for and compiles parsers with `new Function`,
// which our Content Security Policy forbids (no 'unsafe-eval').
// Schemas read this when they are created, so it must run before any of them.
z.config({ jitless: true });
